import { useQuery } from "@tanstack/react-query";
import request from "../utils/request";

const useGetSoftwareInformationById = (id) => {
	return useQuery({
		queryKey: ["software-information", id],
		queryFn: async () => {
			const response = await request.getAllById("software-information", id);

			return response?.status === "OK" ? response.data : null;
		},
		placeholderData: null,
		staleTime: 1000 * 60 * 60 * 24, // 24 hours
		enabled: !!id,
	});
};
export { useGetSoftwareInformationById };
